export const aboutText = [
  "I'm a passionate Computer Science & Business Systems graduate from Francis Xavier Engineering College with a CGPA of 8.6. My expertise lies in developing innovative AI solutions and building robust web applications using Python and modern frameworks.",
  "My journey includes creating autonomous robots for medicinal plant detection, developing voice cloning systems, and building intelligent chatbots. I've successfully led teams in hackathons, published patents, and gained recognition at international exhibitions.",
  "Currently, I'm expanding my full-stack development skills while working on cutting-edge projects that combine AI, computer vision, and web technologies to solve real-world problems.",
];

export const stats = [
  { id: 1, label: "Projects Completed", value: 5, suffix: "+" },
  // { id: 2, label: "AI Models Deployed", value: 3, suffix: "+" },
  { id: 2, label: "Major Awards Won", value: 3, suffix: "" },
  { id: 3, label: "CGPA Achieved", value: 8.6, suffix: "" },
];